var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEyeClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m4 4 16 16",
  stroke: "#000",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.223 5.637a11.038 11.038 0 0 0-4.491 5.41 2.651 2.651 0 0 0 0 1.906C3.319 17.073 7.316 20 12 20c2.422 0 4.66-.783 6.477-2.108l-1.435-1.436a9.004 9.004 0 0 1-13.444-4.222.65.65 0 0 1 0-.468A9.031 9.031 0 0 1 7.685 7.1L6.223 5.637ZM9.48 8.894a4 4 0 1 0 5.627 5.627l-1.43-1.43a2 2 0 1 1-2.768-2.767l-1.43-1.43Zm6.483 3.655-4.511-4.512a4 4 0 0 1 4.511 4.511Zm2.605 2.605a9.002 9.002 0 0 0 1.834-2.92.65.65 0 0 0 0-.468A9.004 9.004 0 0 0 9.709 6.294l-1.59-1.59A10.975 10.975 0 0 1 12 4c4.683 0 8.681 2.927 10.268 7.047a2.65 2.65 0 0 1 0 1.906 11.006 11.006 0 0 1-2.286 3.615l-1.414-1.414Z",
  fill: "#231F20"
})));
export default SvgEyeClose;